import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import BriefTextField from 'src/components/BriefTextField';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { CONTEXT_BRIEF_FIELD } from 'src/data/brief';

import { DEFAULT_INPUT_PROPS } from '../../const';

import { useStyles } from './useStyles';

export const FormContext = ({
  className,
  content,
  onFieldChange,
  onFieldFocus,
  onFieldBlur,
  errors,
  disabled,
}) => {
  const styles = useStyles();

  const valueTextBeforeContext = content[CONTEXT_BRIEF_FIELD.textBefore] || '';
  const handleTextBeforeChange = useCallback(
    (value) => {
      onFieldChange(CONTEXT_BRIEF_FIELD.textBefore, value);
    },
    [onFieldChange]
  );

  const valueTextAfterContext = content[CONTEXT_BRIEF_FIELD.textAfter] || '';
  const handleTextAfterChange = useCallback(
    (value) => {
      onFieldChange(CONTEXT_BRIEF_FIELD.textAfter, value);
    },
    [onFieldChange]
  );

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.medium14}
      >
        Context <span className={styles.optional}>(optional)</span>
      </CustomTypography>
      <div className={styles.wrapper}>
        <BriefTextField
          className={styles.field}
          rows={2}
          label="Before"
          placeholder="Provide the text that precedes the 'content to improve'"
          value={valueTextBeforeContext}
          onChange={handleTextBeforeChange}
          error={errors && (errors.textBefore || errors.highlight)}
          disabled={disabled}
          InputProps={{
            ...DEFAULT_INPUT_PROPS,
            onFocus: onFieldFocus,
            onBlur: onFieldBlur,
            rowsMax: 4,
          }}
          classes={{ label: styles.label }}
        />
        <BriefTextField
          className={styles.field}
          rows={2}
          label="After"
          placeholder="Provide the text that follows the 'content to improve'"
          value={valueTextAfterContext}
          onChange={handleTextAfterChange}
          error={errors && (errors.textAfter || errors.highlight)}
          disabled={disabled}
          InputProps={{
            ...DEFAULT_INPUT_PROPS,
            onFocus: onFieldFocus,
            onBlur: onFieldBlur,
            rowsMax: 4,
          }}
          classes={{ label: styles.label }}
        />
      </div>
    </div>
  );
};

FormContext.propTypes = {
  className: PropTypes.string,
  content: PropTypes.shape().isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldFocus: PropTypes.func,
  onFieldBlur: PropTypes.func,
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};

FormContext.defaultProps = {
  className: null,
  onFieldFocus: null,
  onFieldBlur: null,
  errors: null,
  disabled: false,
};
